import { Text, Box } from 'braid-design-system';

import type { FCC } from 'src/types/types';

import * as styles from './table.css';

type BoxProps = Parameters<typeof Box>[0];

interface TableElementProps {
  children: BoxProps['children'];
  className?: BoxProps['className'];
  id?: string;
  padding?: BoxProps['padding'];
  paddingLeft?: BoxProps['paddingLeft'];
  paddingRight?: BoxProps['paddingRight'];
  paddingTop?: BoxProps['paddingTop'];
  paddingBottom?: BoxProps['paddingBottom'];
  paddingX?: BoxProps['paddingX'];
  paddingY?: BoxProps['paddingY'];
  margin?: BoxProps['margin'];
  marginLeft?: BoxProps['marginLeft'];
  marginRight?: BoxProps['marginRight'];
  marginTop?: BoxProps['marginTop'];
  marginBottom?: BoxProps['marginBottom'];
  marginX?: BoxProps['marginX'];
  marginY?: BoxProps['marginY'];
  textAlign?: BoxProps['textAlign'];
}

export const Th = ({
  children,
  textAlign = 'left',
  ...rest
}: TableElementProps) => (
  <Box {...rest} component="th" textAlign={textAlign}>
    <Text size="small" tone="secondary">
      {children}
    </Text>
  </Box>
);

export const Td = ({ children, ...rest }: TableElementProps) => (
  <Box {...rest} component="td" style={{ verticalAlign: 'middle' }}>
    {children}
  </Box>
);

export const Tr = ({ children, ...rest }: TableElementProps) => (
  <Box {...rest} component="tr" background="surface" className={styles.tr}>
    {children}
  </Box>
);

export const Table: FCC = ({ children }) => (
  <Box component="table" className={styles.table}>
    {children}
  </Box>
);
